import rectangleIconButtonUrl from './rectangleIconButton.html';

export default {
  templateUrl: rectangleIconButtonUrl,
  controllerAs: 'ctrl',
  bindings: {
    icon: '<',
    onPress: '&',
  },
};
